import type { IEtazhiBlackFridayPricesData } from 'shared/types/etazhiBlackFriday';

import type { TEtazhiBlackFridayActions } from './actions';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-251228
 */
export type IEtazhiBlackFridayState = { pricesData: IEtazhiBlackFridayPricesData | null } | null;

const initialState: IEtazhiBlackFridayState = { pricesData: null };

export function etazhiBlackFridayReducer(
  state: IEtazhiBlackFridayState = initialState,
  action: TEtazhiBlackFridayActions,
): IEtazhiBlackFridayState {
  switch (action.type) {
    case 'etazhiBlackFriday/setPricesData':
      return {
        ...state,
        pricesData: action.payload,
      };

    default:
      return state;
  }
}
